
export const locale = {
  'DIALOG' : {
    'CREATE_MANAGER' : {
      'TITLE' : {
        'CREATE' : 'Создать менеджера',
        'EDIT' : 'Редактировать менеджера',
      },
      'CONFIRMBUTTON' : {
        'CREATE' : 'Создать',
        'SAVE' : 'Сохранить',
      },
      'FULLNAME' : 'ФИО',
    },
    'ERROR' : {
      'ALREADYEXISTS' : 'Невозможно создать аккаунт, т.к. уже существует аккаунт с таким логином',
    }
  },
};
